import axios from "axios";

export function editPrivacyPolicy() {
  return axios.get("api/settings/privacy-policy/edit");
}

export function updatePrivacyPolicy(form) {
  return axios.post("api/settings/privacy-policy/update", form);
}
